module.exports = __webpack_public_path__ + "img/compare.b20b6166.svg";